import "./App.scss";
import { FunctionComponent } from "react";
import { ApolloClient, NormalizedCacheObject } from "@apollo/client";
import ApolloClientContext from "./ApolloClientContext";
import { AppRouter } from "routes/AppRouter";
import 'react-toastify/dist/ReactToastify.css';
import "react-datepicker/dist/react-datepicker.css"
import AdyenToastContainer from "components/AdyenToastContainer/AdyenToastContainer";
interface IPROPS {
  client: ApolloClient<NormalizedCacheObject>;
}

const App: FunctionComponent<IPROPS> = (props) => {
  return (
    <ApolloClientContext.Provider value={props.client}>
      <AppRouter />
      <AdyenToastContainer />
    </ApolloClientContext.Provider>
  );
};

export default App;
